module.exports = __webpack_public_path__ + "img/icon_location_gray.30b7f43b.svg";